/**
 * Social Links Utilities
 *
 * Utilities for sanitizing and formatting social media usernames
 * to ensure links to Facebook/Instagram work correctly.
 */

/**
 * Sanitize a social media username by stripping leading @ symbols
 * and trimming whitespace.
 *
 * @param {string|null|undefined} username - The username to sanitize
 * @returns {string} The sanitized username
 *
 * @example
 * sanitizeSocialUsername('@robertduckcomedy') // => 'robertduckcomedy'
 * sanitizeSocialUsername('robertduckcomedy')  // => 'robertduckcomedy'
 * sanitizeSocialUsername('  @user  ')         // => 'user'
 */
export function sanitizeSocialUsername(username) {
  if (!username) {
    return '';
  }

  // Trim whitespace and strip leading @ symbols
  return username.trim().replace(/^@+/, '');
}
